import React, { Component } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import Button from "@material-ui/core/Button";
import { ThemeProvider } from "@material-ui/styles";
import actionBarTheme from "../themes/actionBarTheme";
import { toCamelCase } from "@defi/core-utils";
const useStyles = makeStyles(theme => ({
  actionBar: {
    width: "100%",
    // backgroundColor: '#f5f5f5',
    position: "fixed",
    bottom: 0,
    margin: 0,
    padding: 0
  },
  flexer: {
    flex: "1 1 auto"
  },
  button: {
    height: 64,
    borderRadius: 0,
    boxShadow: "none",
    fontSize: 14,
    minWidth: 105
  }
}));
function DefiActionBar(props) {
  const classes = useStyles();
  const children = props.children;
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: actionBarTheme
  }, /*#__PURE__*/React.createElement(Toolbar, {
    className: classes.actionBar,
    "data-testid": "toolbar"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.flexer
  }), children && children.map((action, i) => {
    return /*#__PURE__*/React.createElement(Button, {
      key: i,
      variant: "contained",
      color: action.color,
      className: classes.button,
      onClick: action.onClick,
      disabled: action.disabled,
      "data-test": action.testName ? action.testName : toCamelCase(action.name) + "Button",
      "data-testid": "button-".concat(i)
    }, action.name);
  })));
}
export default DefiActionBar;